/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Capture_CreatingInputs */

const en_capture_creating = /** @type {(inputs: Capture_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Creating…`)
};

const he_capture_creating = /** @type {(inputs: Capture_CreatingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`יוצר…`)
};

/**
* | output |
* | --- |
* | "Creating…" |
*
* @param {Capture_CreatingInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const capture_creating = /** @type {((inputs?: Capture_CreatingInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Capture_CreatingInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_capture_creating(inputs)
	return he_capture_creating(inputs)
});